/**
 * Initiates a file download in the browser from given data.
 * @param data - The file content (string, Blob, ArrayBuffer, or Uint8Array).
 * @param filename - The name of the file to be downloaded.
 * @param mimeType - The MIME type of the file (default: 'application/octet-stream').
 */
export function downloadFile(data: string | Blob | ArrayBuffer | Uint8Array, filename: string, mimeType: string = 'application/octet-stream'): void {
    let blob: Blob;

    if (typeof data === 'string') {
        // Convert string data to Blob
        blob = new Blob([data], { type: mimeType });
    } else if (data instanceof Blob) {
        blob = data;
    } else if (data instanceof ArrayBuffer) {
        // Convert ArrayBuffer to Blob
        blob = new Blob([data], { type: mimeType });
    } else if (data instanceof Uint8Array) {
        // Convert Uint8Array to Blob - ensure it's an ArrayBuffer
        const arrayBuffer = data.buffer.slice(data.byteOffset, data.byteOffset + data.byteLength) as ArrayBuffer;
        blob = new Blob([arrayBuffer], { type: mimeType });
    } else {
        throw new Error('Unsupported data type for download.');
    }

    // Create object URL and trigger the download
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
}
